// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".workBenchActionList--1QGxvQZp {\n  display: flex;\n  flex-direction: column;\n  width: -webkit-min-content;\n  width: -moz-min-content;\n  width: min-content;\n  height: 100%;\n  background-color: #4297ff;\n}\nhtml[data-theme=\"dark-v2\"] .workBenchActionList--1QGxvQZp,\n[data-override-theme=\"dark-v2\"] .workBenchActionList--1QGxvQZp {\n  background-color: #323237;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"workBenchActionList": "workBenchActionList--1QGxvQZp"
};
export default ___CSS_LOADER_EXPORT___;
